import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class ErrorFlagCellRenderer extends PureComponent {
  handleChange = event => {
    const { data, context } = this.props;
    const nextValue = event.target.checked ? 'Y' : 'N';
    context?.onToggleErrorFlag({
      jobId: data.jobId,
      schemaType: data.schemaType,
      errorMsgFlag: nextValue,
      onlyErrors: context?.onlyErrors,
    });
  };

  render() {
    const { value, data, context } = this.props;
    const isUpdating = context?.updatingJobIds?.includes(`${data.schemaType}-${data.jobId}`);

    return (
      <input
        type="checkbox"
        className="form-check-input m-0"
        style={{ accentColor: '#d04a02' }}
        checked={value === 'Y'}
        disabled={isUpdating}
        onChange={this.handleChange}
      />
    );
  }
}

ErrorFlagCellRenderer.propTypes = {
  value: PropTypes.string,
  data: PropTypes.shape({
    jobId: PropTypes.number,
    schemaType: PropTypes.string,
  }),
  context: PropTypes.shape({
    onToggleErrorFlag: PropTypes.func,
    updatingJobIds: PropTypes.arrayOf(PropTypes.string),
    onlyErrors: PropTypes.bool,
  }),
};

export default ErrorFlagCellRenderer;
